/**
 * Dropdown
 */

// Custom
import 'protons';

// Module template
import './_forms.twig';
import './captcha';

// Import custom sass, includes Bootstrap sass
import './_forms.scss';

export const name = 'forms';

export function disable() {}

export function enable() {}

export default enable;
